import { SimplePage } from "@/app/_/marketing/SimplePage";

export default function Page() {
  return (
    <SimplePage
      eyebrow="Team"
      title="Building the accounting platform we wish existed."
      subtitle="Neoledger is a small team of engineers, accountants, and operators who've lived the pain of running small businesses on spreadsheets and legacy software."
      primaryCta={{
        label: "Get in touch",
        to: "/company/contact",
      }}
      secondaryCta={{
        label: "See open roles",
        to: "/company/careers",
      }}
    />
  );
}
